<ng-container *ngIf="material.no_of_doses === 1">
  <ion-row class="vaccine-names">
    <ion-col size="12" size-lg="12">
      <mat-checkbox (change)="onMaterialChange($event)" color="primary">
        {{ materialName }}</mat-checkbox
      >
    </ion-col>
  </ion-row>
</ng-container>
<ng-container *ngIf="material.no_of_doses > 1">
  <ion-row class="vaccine-names">
    <ion-col size="12" size-lg="12">
      <mat-checkbox (change)="onMaterialChange($event)" color="primary">{{
        materialName
      }}</mat-checkbox>
    </ion-col>
  </ion-row>
  {{ this.sessionVaccStore.materials() | json }}

  <ion-row *ngIf="isMaterialSelected()" class="fade-in">
    <ion-col size="12">
      <ion-card class="detailsCard">
        <mat-radio-group (change)="onSelectDose($event)">
          <ng-container
            *ngFor="
              let dose of [].constructor(material.no_of_doses);
              let i = index
            "
          >
            <app-material-dose
              [materialInfo]="materialInfo()"
              [doseNo]="i + 1"
            ></app-material-dose>
          </ng-container>
        </mat-radio-group>
      </ion-card>
    </ion-col>
  </ion-row>
</ng-container>
